import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../common/formik/FormikButton';
import FormikGrid from '../../common/formik/FormikGrid';
import FormikTextField from '../../common/formik/FormikTextField';
import { Group } from './Group.interface';
import { useCreateGroup } from './Group.hooks';

export interface GroupCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (group: Group) => void;
}

const GroupCreateDialog: React.FC<GroupCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const { group, isLoading, error, post } = useCreateGroup();
  useEffect(() => {
    if (!isLoading) {
      if (onCreated && group) {
        onCreated(group);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [isLoading, onCreated, group]);
  return (
    <Dialog open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ name: '', description: '' }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(groupDto: Partial<Group>) => {
          post(groupDto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>New Team</DialogTitle>
          <DialogContent>
            <DialogContentText>Team Information</DialogContentText>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Team Name'
              />
              <FormikTextField
                type='text'
                name='description'
                label='Description'
              />
            </FormikGrid>

            {error && (
              <Alert severity='error'>
                Error occurred. Please check your internet connection and try
                again.
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default GroupCreateDialog;
